<template>
  <section class="custom-progress-wrapper">
    {{ percent }}
  </section>
</template>
<script>
import globals from '@/Plugins/globals'
export default {
  name: 'component-progress',
  props: {
    data: {
      type: Array,
      default: [],
    },
    isRaw: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    percent() {
      let _percent = 0
      let _target = 0
      let _total = 0
      // console.log('Percent', this.data)
      if (this.data) {
        if (this.data.length > 0) {
          _target = this.data[0].target
          if (this.isRaw) {
            _total = this.data.length
          } else {
            this.data.forEach((element) => {
              if (element.viewed) {
                _total += parseInt(element.viewed)
              }
            })
          }
          if (_target > 0) {
            _percent = (_total / _target) * 100
          }
        }
      }
      return _percent.toFixed(0) + '%'
    },
    target() {
      let _target = 0
      if (this.data) {
        _target = this.data[0].target
      }
      return _target
    },
    media() {
      let _data = []
      if (this.data) {
        if (this.isRaw) {
          let temp = JSON.parse(JSON.stringify(this.data))
          temp = globals.sortArray(temp, 'name', 'asc')
          let last = null
          let cnt = 0
          temp.forEach((element) => {
            if (last !== null && last !== element.name) {
              _data.push({
                name: last,
                viewed: cnt,
              })
              cnt = 0
            }
            cnt++
            last = element.name
          })
          _data.push({
            name: last,
            viewed: cnt,
          })
        } else {
          _data = this.data
        }
      }
      return _data
    },
    total() {
      let _total = 0
      if (this.data) {
        if (this.isRaw) {
          _total = this.data.length
        } else {
          this.data.forEach((element) => {
            if (element.viewed) {
              _total += parseInt(element.viewed)
            }
          })
        }
      }
      return _total
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-progress-wrapper {
  text-align: center;
}
.custom-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 1em 0;
}
.custom-right {
  text-align: right;
  padding-right: 5px;
}
.custom-header {
  border-bottom: 1px solid rgb(82, 82, 82);
}
.custom-header-right {
  border-bottom: 1px solid rgb(82, 82, 82);
  text-align: right;
}
.custom-total {
  border-top: 1px solid rgb(82, 82, 82);
  text-align: right;
}
</style>